import React from 'react';
import { Tabs } from 'antd';
import SettingsDropdowns from '../../containers/PaidMedia.js/SettingsDropdowns';
import Reporting from '../../containers/PaidMedia.js/Reporting';

function Pinterest() {

    const tabs = [
        {
            label: 'Settings',
            key: 'Settings',
            children: [<SettingsDropdowns platform='pinterest'></SettingsDropdowns>]
        },
        {
            label: 'Reporting',
            key: 'Reporting',
            children: [<Reporting platform='pinterest'></Reporting>]
        }
    ]

    return (
        <div>
            <Tabs style={{
                'width': '80vw',
                'marginLeft': '1vw',
            }} items={tabs} defaultActiveKey='Reporting' ></Tabs>
        </div>
    );
}

export default Pinterest;
